import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

//Dimensions: columns in CAMPAIGN table
export const DimensionIds = dbTableCampaign.DimensionIds;

export type ICampaignDimension = dbTableCampaign.ICampaignDimension;

//reexport enum
export { DimensionTags } from "@dataseat-dsp-client/lib-reporter";
